module.exports = __webpack_public_path__ + "static/media/arrow.min.cop.fad5c417.svg";